import { FILE_ICONS } from "@/components/file-uploader/file-icons";

export function FileIcon({
  extension,
}: {
  extension: boolean | null | string;
}) {
  if (typeof extension === "string" && extension in FILE_ICONS) {
    const IconComponent = FILE_ICONS[extension as keyof typeof FILE_ICONS];

    return <IconComponent className="size-xl shrink-0" />;
  } else {
    const IconComponent = FILE_ICONS.fallback;

    return <IconComponent className="size-xl shrink-0" />;
  }
}
